import hash from 'object-hash';
import _ from 'lodash';
import { listStoreBuilder } from '@/main/store/pages/list/builder';
import { Row, Table } from '@/main/utils/table';
import { Status } from '@/main/store/@types/page';
import { objectToCamelCaseShallow } from '@/main/utils/stringHelper';
import { STORE_TABLE, UPDATE_BASIC_TABLE_DATA } from '@/main/store/listEditTypes';

import { CRUMB_LABEL_KEY, NAME } from '../constants';
import { apiProvider } from '../api';


const filter = {
	VozidloId: null as number | null,
	NvSkladId: null as number | null,
	VyrazenPrp: null as number | null,
};

export const store = listStoreBuilder({
	name: NAME,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList: {},
	filter,
	tableSetting: {},
	rowDetail: null,
	localState: {
		tableHash: null as string | null,
	},
	extraActions: {},
	extraMutations: {
		[UPDATE_BASIC_TABLE_DATA](state, { data, tableName = STORE_TABLE }: { stateKey: number, data: any, tableName: string }) {
			const table = _.get(state, tableName) as Table;
			table.status = Status.ok;
			table.rows = data.map((row: Row) => objectToCamelCaseShallow(row));
			table.emptyTextKey = 'TableMsgNoData';
			table.isEditable = true;
			state.localState.tableHash = hash(table.rows);
		},
	},
	extraGetters: {},
	props: {
		filter: {},
		mode: null,
		afterRowSelection: () => {},
		previousStoreUri: null as string | null,
		previousEntityId: null as number | null,
	},
});
